var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStbltrackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.825 30.6471L27.3 30.6471C29.3742 30.6471 30.4113 30.6471 31.0556 29.9924C31.7 29.3377 31.7 28.2839 31.7 26.1765L31.6999 19.1912L16.3001 19.1912L16.3 26.1765C16.3 28.2839 16.3 29.3377 16.9444 29.9924C17.5887 30.6471 18.6258 30.6471 20.7 30.6471L23.175 30.6471L23.175 25.0895L22.4264 25.9769C22.1298 26.3284 21.609 26.3691 21.2631 26.0678C20.9171 25.7665 20.8771 25.2373 21.1736 24.8859L23.3736 22.278C23.5303 22.0922 23.7591 21.9853 24 21.9853C24.2408 21.9853 24.4696 22.0922 24.6264 22.278L26.8264 24.8859C27.1229 25.2373 27.0828 25.7665 26.7369 26.0678C26.3909 26.3691 25.8701 26.3284 25.5736 25.9769L24.825 25.0895L24.825 30.6471Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6663 17.5147L16.3337 17.5147C16.39 16.6311 16.5409 16.0647 16.9444 15.6547C17.5887 15 18.6258 15 20.7 15L27.3 15C29.3742 15 30.4113 15 31.0556 15.6547C31.4591 16.0647 31.61 16.6311 31.6663 17.5147Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7222 34L17.2778 34C14.9152 34 13 31.9883 13 29.5067C13 28.0656 13.6458 26.783 14.65 25.9608L14.65 26.2765C14.6499 27.2439 14.6498 28.131 14.7453 28.8526C14.8504 29.6472 15.0978 30.487 15.7777 31.1778C16.4575 31.8685 17.2841 32.1199 18.0662 32.2267C18.7764 32.3237 19.6494 32.3236 20.6016 32.3235L27.3985 32.3235C28.3507 32.3236 29.2237 32.3237 29.9339 32.2267C30.7159 32.1199 31.5425 31.8685 32.2224 31.1778C32.9022 30.487 33.1496 29.6472 33.2548 28.8526C33.3503 28.131 33.3501 27.244 33.35 26.2765L33.35 25.9608C34.3542 26.7831 35 28.0656 35 29.5067C35 31.9883 33.0848 34 30.7222 34Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStbltrackIcon);
export default __webpack_public_path__ + "static/media/stbltrackIcon.3b475c353f6289b10b55fa4b27052fac.svg";
export { ForwardRef as ReactComponent };